// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KkSbk","rootClassForHOELT":"Header_rootClassForHOELT__z-hL6","content":"Header_content__e8Iuw","text":"Header_text__4jGdp","logo":"Header_logo__UsziS"};